import Input from 'components/_parts/atoms/input';
import TextEditor from 'components/_parts/atoms/textEditor';
import { useFormikContext } from 'formik';
import { useCallback, useEffect } from 'react';
import styled from 'styled-components';
import Label from 'components/_parts/atoms/label';

const WrapperForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-top: 20px;
  max-width: 315px;
  height: inherit;
`;

function Form({ t }) {
  const formik = useFormikContext();
  const handleChange = useCallback(
    (name, editorData) => {
      formik.setFieldValue(name, editorData === '\n' ? '' : editorData);
    },
    [formik.setFieldValue, formik.values.description],
  );

  return (
    <WrapperForm>
      <Input
        name="name"
        type="text"
        value={formik.values.name}
        placeholder={t('company.company_name')}
        isError={formik.errors.name && formik.touched.name}
        validateMessage={formik.errors.name}
        onChange={formik.handleChange}
      />
      <div>
        <Label typeLabel="label_option" className="pb-2 tw-text-start">
          {t('company.company_desc')}
        </Label>
        <TextEditor
          name="description"
          placeholder={t('company.ins_desc_comp')}
          value={formik.values.description}
          isError={formik.errors.description && formik.touched.description}
          validateMessage={formik.errors.description}
          onChange={(a, b, c, editor) => {
            handleChange('description', editor.getHTML());
          }}
        />
      </div>
    </WrapperForm>
  );
}

export default Form;
